// extracted by mini-css-extract-plugin
export var logoBrick = "Logo-module--logoBrick--4844c";
export var logoLetter = "Logo-module--logoLetter--9bb78";
export var root = "Logo-module--root--073e0";